import {useRouter} from 'next/router';
import {useRecoilValue} from 'recoil';
import {authInfoState} from '@src/store';
import {closeWebview} from '@src/utils/scheme';

function AuthInfo () {
  const router = useRouter();
  const authInfo = useRecoilValue(authInfoState);

  const handleClickSchemeTest = () => {
    router.push('/test/scheme');
  };
  return (
    <div
      style={{
        border: '1px solid black',
        position: 'fixed',
        bottom: 0,
        right: 0,
        zIndex: 100,
        padding: 5,
      }}
    >
      <p>카로그인: {authInfo.accountId > 0 ? 'ON' : 'OFF'}</p>
      <p>카계정 ID: {authInfo.accountId}</p>
      <p>가입 여부: {authInfo.signup ? 'Y' : 'N'}</p>
      <button style={{display: 'block'}} onClick={handleClickSchemeTest}>
        스킴테스트
      </button>
      <button style={{display: 'block'}} onClick={closeWebview}>
        웹뷰 닫기
      </button>
    </div>
  );
}

export default AuthInfo;
